import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { DesignProvider } from '@/app/DesignProvider'
import App from '@/App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DesignProvider>
      <App />
    </DesignProvider>
  </StrictMode>,
)
